import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CountryCodeInterceptor implements HttpInterceptor {
  public countryData = JSON.parse(localStorage.getItem('countryOfOrigin') || '{}')

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const clonedRequest = req.clone({
      // Send country code to all APIs when we have country else send empty string
      headers: req.headers.set('Country-Code', this.countryData?.code ?? '') 
    });

    return next.handle(clonedRequest);
  }
}